import {Component, OnInit} from '@angular/core';
import {CalendarEventsStore} from '../../data/calendar-events.store';
import {CalendarEventsQuery} from '../../data/calendar-events.query';
import {CalendarEventsService} from '../../data/calendar-events.service';

@Component({
  selector: 'app-filter-button',
  templateUrl: './filter-button.component.html',
  styleUrls: ['./filter-button.component.scss']
})
export class FilterButtonComponent implements OnInit {

  selectedTypeIds: number[] = [];

  constructor(
    protected calendarEventsStore: CalendarEventsStore,
    protected calendarEventsQuery: CalendarEventsQuery,
    protected calendarEventsService: CalendarEventsService
  ) {
  }

  ngOnInit() {
  }

  onTypesFilterChange(typeIds: number[]) {
    this.selectedTypeIds = typeIds;
    this.calendarEventsStore.updateTypeIds(typeIds);
    this.reloadEvents();
  }

  onUsersFilterChange(userIds: number[]) {
    this.calendarEventsStore.updateUserIds(userIds);
    this.reloadEvents();
  }

  reloadEvents() {
    const dateRange = this.calendarEventsQuery.getValue().ui.dateRange;
    if (dateRange && dateRange.start && dateRange.end) {
      this.calendarEventsService.loadEventsForCalendar(dateRange);
    }
  }

}
